import React from 'react';
import {observer} from 'mobx-react';
import {Panel} from 'components';
import {t} from 'shared/core';
import _ from 'lodash';
import CompletedIcon from 'img/list-element-complete@2x.png';
import IncompleteIcon from 'img/list-element-incomplete-default@2x.png';
import {NavLink} from 'react-router-dom';

const ReviewItem = observer(({review, active, index, match}) => {
  return (
    <div className={`clearfix ${index > 0 ? 'mt2' : ''}`}>
      <div className='col col-11'>
        <NavLink
          to={`/reviews/${match.params.cycleId}/write/${review.id}`}
          activeClassName='dodger'
          className='jumbo block TextLink'
        >
          {review.reviewee.employee.name}
        </NavLink>
      </div>
      <div className='col col-1'>
        <img className='align-top' src={review.submitted ? CompletedIcon : IncompleteIcon} width='18' alt='complete'/>
      </div>
    </div>
  );
});

const ReviewSection = observer(({title, reviews, uiState, showBorder = true}) => {
  return (
    <div>
      <Panel.Header title={title}/>
      {reviews.map((review, index) =>
        <ReviewItem index={index}
          key={review.id}
          review={review}
          match={uiState.match}
          active={uiState.currentReview.id === review.id}
        />)}
      {showBorder && <hr style={{marginLeft: '-1.5rem', marginRight: '-1.5rem'}}/>}
    </div>
  );
});

const ReviewList = observer(({uiState}) => {
  const {
    hasSelfReview,
    selfReview,
    directReportReviews,
    hasDirectReportReviews,
    peerReviews,
    hasPeerReviews
  } = uiState;

  return (
    <div>
      <Panel>
        {hasSelfReview && <ReviewSection title={t('performance_reviews.view.Self Review')}
          reviews={selfReview}
          uiState={uiState}
          showBorder={hasDirectReportReviews || hasPeerReviews}/>}

        {hasDirectReportReviews && <ReviewSection title={t('performance_reviews.view.My Direct Reports')}
          reviews={directReportReviews}
          uiState={uiState}
          showBorder={hasPeerReviews}/>}

        {hasPeerReviews && <ReviewSection title={t('performance_reviews.view.My Peers')}
          reviews={peerReviews}
          uiState={uiState}
          showBorder={false}/>}
      </Panel>
    </div>
  );
});

export default ReviewList;
